const SgiFormTextEO = function () {
    return {
        // cId: '',
        alwBlk: true,
        // c: "guid",
        ctlH: 0,
        ctlW: 24,
        lblW: 6,
        desId: "EP_EO_UI_3101",
        isDis: false,
        isHdn: false,
        isLbl: false,
        lblAlg: "right",
        bdText: '',
        maxL: 0,
        minL: 0,
        te: "文本",
        teAl: "left",
        vldC: "",
        inpPopTe: "请输入文本",
        // visible: true,
        // x: "0",
        // y: "0",
        ctlN: "普通文本框",
        // iconPh: "SD_RP_IR_0001`UI`UI09",
        // msfTgt: "qtip",
        // n: "GUID/guid",
        // sNo: 0,
        // t: "text",
        isPwd: false,
        // isRead: false,
        // isSrp: true,
        // isGw: false,
    }
}

export { SgiFormTextEO };
export default SgiFormTextEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiFormTextEO.js